import React from 'react'
import { injectIntl } from 'react-intl'
import { compose } from 'recompose'
import { withStyles, Grid, Typography, CircularProgress, Box } from '@material-ui/core'


const Stepper = ({ stepsCount, selectedStep, stepNumber, intl }) => {
    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={1}
        >
            <Grid 
                item
            >
                <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                    <CircularProgress
                        variant="determinate"
                        size={54}
                        thickness={5}
                        value={selectedStep/stepsCount*100}/
                    >
                    <Box
                        sx={{
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            position: 'absolute',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <Typography
                            data-testid="stepper-stage-value"
                            variant='h4'
                            style={{
                                fontSize: '22px !important',
                                lineHeight: '16px !important',
                                letterSpacing: '2.08px !important',
                                paddingTop: '5px'
                            }}
                        >
                            {selectedStep}/{stepsCount}
                        </Typography>
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Typography
                    data-testid="stepper-stage-name"
                    className="stepper-register-title"
                    variant='subtitle2'
                >
                    {intl.formatMessage({ id: `app.stepper.stage.${stepNumber}` })}
                </Typography>
            </Grid>
       </Grid>
    )
}

const enhance = compose(
    //connect(mapStateToProps, mapDispatchToProps),
    injectIntl
)

export default enhance(Stepper)
